<template>
  <div class="intro">
    <div id="app">
      <div class="text-wrapper">
        <div class="text part1">
          <div>
            <span class="letter">
              <div class="character">L</div>
              <span></span></span>
            <span class="letter">
              <div class="character">o</div>
              <span></span>
            </span>
            <span class="letter">
              <div class="character">a</div>
              <span></span>
            </span>
            <span class="letter">
              <div class="character">d</div>
              <span></span>
            </span>
            <span class="letter">
              <div class="character">i</div>
              <span></span>
            </span>
            <span class="letter">
              <div class="character">n</div>
              <span></span>
            </span>
            <span class="letter">
              <div class="character">g</div>
              <span></span>
            </span>
          </div>
        </div>
        <div class="how-to">
          <span style="font-size: 2em;">{{$t('common.loginLoading')}}<span class="dot-ani"></span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString, setCookie, getLanguage } from '@/utils/utils.js'
import { loginFree } from '@/services/acountApi.js'
import store from '@/store'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      username: '',
      timestamp: '',
      nonce: '',
      sign: ''
    }
  },
  store,
  mounted () {
    let lang = getQueryString('lang')
    if (lang === 'zh_CN') {
      lang = 'zh-cn'
    } else {
      lang = 'en'
    }
    setCookie('language', lang, 3000)
    this.$i18n.locale = getLanguage('language')

    this.username = getQueryString('username')
    this.timestamp = getQueryString('timestamp')
    this.nonce = getQueryString('nonce')
    this.sign = getQueryString('sign')
    if (this.username && this.timestamp && this.nonce && this.sign) {
      this.loginFree()
    } else {
      this.goLogin()
    }
    let themecolor = localStorage.getItem('themecolor')
    if (themecolor) {
      this.setTheme(themecolor)
    } else {
      this.setTheme('#6D5EFF')
      localStorage.setItem('themecolor', '#6D5EFF')
    }
  },
  methods: {
    ...mapActions(['getMenuPermission', 'setTheme', 'setIsLoginAuto']),
    goLogin () {
      this.$router.push({ path: '/login' })
    },
    loginFree () {
      let params = {
        username: this.username,
        timestamp: this.timestamp,
        nonce: this.nonce,
        sign: this.sign
      }
      loginFree(params)
        .then(data => {
          if (data.code === '00000000') {
            this.setIsLoginAuto(true)
            sessionStorage.setItem('LoginAuto', true)
            sessionStorage.setItem('isLogin', true)
            sessionStorage.setItem('loginName', this.userName)
            sessionStorage.setItem(
              'loginInfo',
              JSON.stringify(data.payload.results.userInfo)
            )
            try {
              if (data.payload.results.userInfo.companyId) {
                sessionStorage.setItem(
                  'companyId',
                  data.payload.results.userInfo.companyId
                )
              }
            } catch (error) {

            }

            this.getMenuPermission(this.$router, true)
              .then(data => {
                setTimeout(() => {
                  this.$router.push({ path: data })
                }, 500)
              })
              .catch(data => {
                setTimeout(() => {
                  this.$router.push({ path: '/dashboard' })
                }, 500)
              })
          } else {
            this.$notify({
              title: this.$t('common.tip'),
              message: data.message,
              type: 'warning'
            })
            this.goLogin()
          }
        })
        .catch(e => {
          this.$notify({
            title: this.$t('common.tip'),
            message: e.message || this.$t('common.fail'),
            type: 'warning'
          })
          this.goLogin()
        })
    }
  }
}
</script>
<style scoped lang="less">
   .dot-ani {
      display: inline-block;
      height: 12px;
      line-height: 12px;
      overflow: hidden;
    }
    .dot-ani::after {
      display: inline-table;
      white-space: pre;
      content: "\A.\A..\A...";
      animation: spin 2s steps(4) infinite;
    }
    @keyframes spin {
      to{
        -webkit-transform:translateY(-48px);
        transform:translateY(-48px)
      }
    }

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  font-family: "Fredoka One", cursive;
  font-size: 16px;
  margin: 0px;
}

#app {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.text-wrapper {
  padding: 0 1rem;
  max-width: 50rem;
  width: 100%;
  text-align: center;
}
.text {
  font-size: 8em;
  text-transform: uppercase;
  letter-spacing: -14px;
}
.text .letter {
  position: relative;
  display: inline-block;
  transition: all 0.4s;
  text-shadow: 1px 5px 5px #1878da;
}
.text .letter .character {
  opacity: 0.65;
  transition: color 0.4s;
  cursor: pointer;
}

.text .letter span {
  position: absolute;
  bottom: 0.8rem;
  left: 0.4rem;
  display: block;
  width: 100%;
  height: 15px;
}

.text .letter span::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
}

.text .letter:hover .character {
  color: #fff !important;
}

.text.part1 .letter:nth-child(1).poofed {
  transform-origin: 50% 50%;
  animation: poofing1 1.4s ease-in-out infinite alternate;
}

@keyframes poofing1 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(459deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(459deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(1) .character {
  color: #f44336;
  animation: wave 1.2s linear infinite;
  animation-delay: 0.33333s;
}

.text.part1 .letter:nth-child(1) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 0.33333s;
}

.text.part1 .letter:nth-child(2).poofed {
  transform-origin: 50% 50%;
  animation: poofing2 1.4s ease-in-out infinite alternate;
}

@keyframes poofing2 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(540deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(540deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(2) .character {
  color: #9c27b0;
  animation: wave 1.2s linear infinite;
  animation-delay: 0.66667s;
}

.text.part1 .letter:nth-child(2) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 0.66667s;
}

.text.part1 .letter:nth-child(3).poofed {
  transform-origin: 50% 50%;
  animation: poofing3 1.4s ease-in-out infinite alternate;
}

@keyframes poofing3 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(264deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(264deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(3) .character {
  color: #f99b0c;
  animation: wave 1.2s linear infinite;
  animation-delay: 1s;
}

.text.part1 .letter:nth-child(3) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 1s;
}

.text.part1 .letter:nth-child(4).poofed {
  transform-origin: 50% 50%;
  animation: poofing4 1.4s ease-in-out infinite alternate;
}

@keyframes poofing4 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(42deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(42deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(4) .character {
  color: #cee007;
  animation: wave 1.2s linear infinite;
  animation-delay: 1.33333s;
}

.text.part1 .letter:nth-child(4) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 1.33333s;
}

.text.part1 .letter:nth-child(5).poofed {
  transform-origin: 50% 50%;
  animation: poofing5 1.4s ease-in-out infinite alternate;
}

@keyframes poofing5 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(384deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(384deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(5) .character {
  color: #00c6b2;
  animation: wave 1.2s linear infinite;
  animation-delay: 1.66667s;
}

.text.part1 .letter:nth-child(5) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 1.66667s;
}

.text.part1 .letter:nth-child(6).poofed {
  transform-origin: 50% 50%;
  animation: poofing6 1.4s ease-in-out infinite alternate;
}

@keyframes poofing6 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(156deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(156deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(6) .character {
  color: #f44336;
  animation: wave 1.2s linear infinite;
  animation-delay: 2s;
}

.text.part1 .letter:nth-child(6) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 2s;
}

.text.part1 .letter:nth-child(7).poofed {
  transform-origin: 50% 50%;
  animation: poofing7 1.4s ease-in-out infinite alternate;
}

@keyframes poofing7 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(156deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(156deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part1 .letter:nth-child(7) .character {
  color: #4caf50;
  animation: wave 1.2s linear infinite;
  animation-delay: 2.5s;
}

.text.part1 .letter:nth-child(7) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 3s;
}

.text.part2 span:nth-child(1).poofed {
  animation: sec_poofing1 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing1 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(268deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(268deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(1) .character {
  color: #ff5a5f;
  animation: wave 1.2s linear infinite;
  animation-delay: 2.33333s;
}

.text.part2 span:nth-child(1) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 2.33333s;
}

.text.part2 span:nth-child(2).poofed {
  animation: sec_poofing2 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing2 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(135deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(135deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(2) .character {
  color: #f99b0c;
  animation: wave 1.2s linear infinite;
  animation-delay: 2.66667s;
}

.text.part2 span:nth-child(2) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 2.66667s;
}

.text.part2 span:nth-child(3).poofed {
  animation: sec_poofing3 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing3 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(442deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(442deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(3) .character {
  color: #cee007;
  animation: wave 1.2s linear infinite;
  animation-delay: 3s;
}

.text.part2 span:nth-child(3) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 3s;
}

.text.part2 span:nth-child(4).poofed {
  animation: sec_poofing4 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing4 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(525deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(525deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(4) .character {
  color: #00c6b2;
  animation: wave 1.2s linear infinite;
  animation-delay: 3.33333s;
}

.text.part2 span:nth-child(4) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 3.33333s;
}

.text.part2 span:nth-child(5).poofed {
  animation: sec_poofing5 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing5 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(419deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(419deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(5) .character {
  color: #4e2a84;
  animation: wave 1.2s linear infinite;
  animation-delay: 3.66667s;
}

.text.part2 span:nth-child(5) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 3.66667s;
}

.text.part2 span:nth-child(6).poofed {
  animation: sec_poofing6 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing6 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(246deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(246deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(6) .character {
  color: #9c27b0;
  animation: wave 1.2s linear infinite;
  animation-delay: 4s;
}

.text.part2 span:nth-child(6) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 4s;
}

.text.part2 span:nth-child(7).poofed {
  animation: sec_poofing7 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing7 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(206deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(206deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(7) .character {
  color: #f99b0c;
  animation: wave 1.2s linear infinite;
  animation-delay: 4.33333s;
}

.text.part2 span:nth-child(7) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 4.33333s;
}

.text.part2 span:nth-child(8).poofed {
  animation: sec_poofing8 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing8 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(60deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(60deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(8) .character {
  color: #cee007;
  animation: wave 1.2s linear infinite;
  animation-delay: 4.66667s;
}

.text.part2 span:nth-child(8) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 4.66667s;
}

.text.part2 span:nth-child(9).poofed {
  animation: sec_poofing9 1.4s ease-in-out infinite alternate;
}

@keyframes sec_poofing9 {
  0% {
    transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);
  }
  50% {
    transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);
  }
  56% {
    transform: rotateZ(496deg) rotateY(360deg) translateY(0px) scale(1);
  }
  100% {
    transform: rotateZ(496deg) rotateY(360deg) translateY(-700px) scale(0.01);
  }
}

.text.part2 span:nth-child(9) .character {
  color: #00c6b2;
  animation: wave 1.2s linear infinite;
  animation-delay: 5s;
}

.text.part2 span:nth-child(9) span::before {
  animation: shadow 1.2s linear infinite;
  animation-delay: 5s;
}

@keyframes wave {
  0% {
    transform:  rotateZ(-10deg)  translateY(0);
  }
  50% {
    transform: rotateZ(10deg) translateY(-10px);
  }
  100% {
    transform:rotateZ(-10deg) translateY(0);
  }
}

@keyframes shadow {
  0% {
    width: 0;
    height: 0;
  }
  50% {
    width: 100%;
    height: 100%;
  }
  100% {
    width: 0;
    height: 0;
  }
}

.how-to {
  margin: 2rem 0 2rem 1rem;
  font-family: "Opens Sans", sans-serif;
  font-weight: 300;
  font-size: 0.85em;
  letter-spacing: 4px;
  color: #fff;
}

@keyframes rotate {
  0% {
    transform: rotateZ(0) scale(0.7);
  }
  100% {
    transform: rotateZ(360deg) scale(0.7);
  }
}

@media only screen and (max-width: 767px) {
  .text {
    font-size: 6em;
  }
  .text .letter span {
    bottom: 0.5rem;
  }
}

@media only screen and (max-width: 480px) {
  .text {
    font-size: 4em;
  }
  .text .letter span {
    bottom: 0;
  }
}
// .loading {
//   height: 40px;
//   margin: 20px auto;
// }
// .loading span {
//   display: inline-block;
//   width: 8px;
//   height: 100%;
//   border-radius: 4px;
//   background: lightgreen;
// }
//   0%,
//   100% {
//     height: 40px;
//     background: lightgreen;
//   }
//   50% {
//     height: 70px;
//     margin: -15px 0;
//     background: lightblue;
//   }
// }
// .loading span:nth-child(2) {
// }
// .loading span:nth-child(3) {
// }
// .loading span:nth-child(4) {
// }
// .loading span:nth-child(5) {
// }
</style>



// WEBPACK FOOTER //
// src/components/loginAuto1.vue